// Photos are loaded from category subfolders: src/img/slider/<category>/
// Naming convention: portrait_1.webp, family_3.webp, real-estate_2.webp, etc.
// Add new photos with the next sequential number — no renaming needed.
// Gallery always shows newest (highest number) first within each category.

const CATEGORIES = ['portrait', 'family', 'events', 'animals', 'business', 'blackwhite'];

// How many photos per category appear first in the "All" view (total = 9)
const INITIAL_CATEGORY_LIMITS = {
  portrait:   2,
  business:   2,
  events:     1,
  family:     2,
  animals:    1,
  blackwhite: 1,
};

const contexts = {
  portrait:   require.context('../img/slider/portrait',   false, /\.(jpg|jpeg|png|webp)$/),
  family:     require.context('../img/slider/family',     false, /\.(jpg|jpeg|png|webp)$/),
  events:     require.context('../img/slider/events',     false, /\.(jpg|jpeg|png|webp)$/),
  animals:    require.context('../img/slider/animals',    false, /\.(jpg|jpeg|png|webp)$/),
  business:   require.context('../img/slider/business',   false, /\.(jpg|jpeg|png|webp)$/),
  blackwhite: require.context('../img/slider/blackwhite', false, /\.(jpg|jpeg|png|webp)$/),
};

const getNumFromFile = (file) => {
  const match = file.match(/_(\d+)\./);
  return match ? Number(match[1]) : 0;
};

const createItems = (category, ctx) =>
  ctx
    .keys()
    .sort((a, b) => getNumFromFile(b) - getNumFromFile(a)) // newest first
    .map((file) => {
      const num = getNumFromFile(file);
      return {
        id:       `${category}-${num}`,
        num,
        src:      ctx(file).default || ctx(file),
        category,
        title:    `${category} ${num}`,
      };
    });

// Grouped by category — used for accurate counts and per-category filtering
const grouped = Object.fromEntries(
  CATEGORIES.map((cat) => [cat, createItems(cat, contexts[cat])])
);

// Balanced initial batch for the "All" view (2+2+2+2+1 = 9 photos)
const initialPhotos = CATEGORIES.flatMap((cat) =>
  grouped[cat].slice(0, INITIAL_CATEGORY_LIMITS[cat] ?? 0)
);

const usedIds = new Set(initialPhotos.map((p) => p.id));

// Remaining photos — all categories in order, excluding already shown
const restPhotos = CATEGORIES.flatMap((cat) => grouped[cat])
  .filter((p) => !usedIds.has(p.id));

// Full flat array: balanced initial batch + the rest
const photoGallery = [...initialPhotos, ...restPhotos];

export { photoGallery, grouped };